import React from "react";

const Template0 = () => {
  return (
    <div className="customer-popup-name__preview-box-text">
      クリエイティブが設定されていません
    </div>
  );
};

export default Template0;
